var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeatherNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.11 11.37a.3.3 0 1 0 .41-.43c-2.89-3.13-7.69 5.32-.34 7.11a.34.34 0 0 0 .18-.66A3.6 3.6 0 0 1 4.43 14c.04-1.75 1.29-3.8 2.68-2.63Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33 10.73c.7-3.08-2.92-5-5.26-4a4.32 4.32 0 0 0-1.24.82 3.14 3.14 0 0 0-4.14-.88 5.8 5.8 0 0 0-1.26 1 4.68 4.68 0 0 0-.8 2.09.33.33 0 0 0 .45.43.37.37 0 0 0 .2-.21A4.13 4.13 0 0 1 9 8.18a3.71 3.71 0 0 1 1.92-1.1c.79-.08 2 .34 2.14 1.11l0 .32a.51.51 0 0 0 .31.5c.63.26.81-.78 2.18-1.31a3.3 3.3 0 0 1 2.82.49c1.61 1.14.76 2.71.74 3.1a.6.6 0 0 0 .51.65c.12 0 .77-.14 1.1-.16a2.63 2.63 0 0 1 2.06 1 2.13 2.13 0 0 1 .34 1.92 4.7 4.7 0 0 1-.93 1.9c-1.06 1.2-2.11.6-2.07 1.2a.3.3 0 0 0 .31.28c1.86-.07 2.9-1.39 3.47-3.14a3.25 3.25 0 0 0-3.57-4.21Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07 10.11a.3.3 0 0 0 .4-.44c-.91-.94-.47-2.57.46-3.54a3.44 3.44 0 0 1 4.59-.58.34.34 0 0 0 .46-.5 4.11 4.11 0 0 0-5.92.35C3 6.86 2.68 9 4.07 10.11Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08 6.8c-.75-.13-1-.41-1.87.27a.3.3 0 0 0 .18.57c.61.04.53.36 1.77-.17a.34.34 0 1 0-.08-.67Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74 3.54c-.41-.62-.56-1-1.61-1.15a.3.3 0 0 0-.26.54c.21.22.24.57.8.86.24.12.45.19.63.27a.34.34 0 0 0 .44-.52Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91 2.44a.34.34 0 0 0 .68 0 4.35 4.35 0 0 0 .27-1 2.51 2.51 0 0 0-.22-1 .3.3 0 1 0-.6 0c-.34.85-.46.76-.13 2Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.15 4.14a5.89 5.89 0 0 1 .58-.38c.56-.42.52-.56.85-1.1a.3.3 0 0 0-.4-.45 2.57 2.57 0 0 0-1 .54 2.67 2.67 0 0 0-.63 1.07.34.34 0 0 0 .6.32Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 15.06a4.12 4.12 0 0 0-1.1 3.44c.55 2.34 3.75 2.15 3.38-.61-.19-1.45-1.34-3.96-2.28-2.83Zm1.49 4c-.29.58-1.47.53-1.58-.68a3.66 3.66 0 0 1 .71-2.23c.42.65 1.2 2.11.87 2.85Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18.76a4.17 4.17 0 0 0-1.1 3.44c.55 2.33 3.77 2.2 3.38-.61-.22-1.44-1.36-3.96-2.28-2.83ZM9.44 23a1.07 1.07 0 0 1-.56-1 3.69 3.69 0 0 1 .72-2.2 10.88 10.88 0 0 1 .87 1.94c.28 1.16-.3 1.58-1.03 1.26Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.93 18.76a4.14 4.14 0 0 0-1.1 3.44c.55 2.33 3.76 2.2 3.38-.61-.21-1.44-1.34-3.95-2.28-2.83Zm1.49 3.95c-.26.57-1.46.56-1.58-.67a3.63 3.63 0 0 1 .72-2.24c.44.69 1.2 2.2.86 2.91Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherNews);
export default __webpack_public_path__ + "static/media/weather-news.5672fa4bf813fcd36d8f0727414996d8.svg";
export { ForwardRef as ReactComponent };